// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._2YHWEZt9x{display:flex;flex-direction:column;flex:1;background:#f8f8f8;padding-bottom:40px}._36E89Kfxx{padding-bottom:40px}._7ai5lSrlx{width:100%;margin-left:auto;margin-right:auto}@media (min-width: 768px){._7ai5lSrlx{max-width:680px}}._1mpGR0Nrx{height:48px;padding:0 20px;border-top:1px solid var(--gray-8);border-bottom:1px solid var(--gray-8);background-color:white}._3sxm8xFHx{margin-left:auto;background-color:white}._3Y5v0x5lx{display:block;text-align:center}._6cvoe9rNx{min-height:initial;flex:1}._6cvoe9rNx>img{height:81px;margin-bottom:20px}._6cvoe9rNx>div[class*=\"empty-state-title-\"]{font-size:20px}._2wOt0ywZx{display:block}._7JO3NF8qx{display:none}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"releases": "_2YHWEZt9x",
	"top-release": "_36E89Kfxx",
	"topRelease": "_36E89Kfxx",
	"responsive-constraint": "_7ai5lSrlx",
	"responsiveConstraint": "_7ai5lSrlx",
	"title-bar": "_1mpGR0Nrx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"titleBar": "_1mpGR0Nrx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"title-controls": "_3sxm8xFHx",
	"titleControls": "_3sxm8xFHx",
	"see-all-versions": "_3Y5v0x5lx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["space-xl-above"] + "",
	"seeAllVersions": "_3Y5v0x5lx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["space-xl-above"] + "",
	"no-releases": "_6cvoe9rNx",
	"noReleases": "_6cvoe9rNx",
	"visible": "_2wOt0ywZx",
	"hidden": "_7JO3NF8qx"
};
module.exports = exports;
